export default "__VITE_ASSET__DgYe6Jux__"